import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = {
    url: String,
    active: Boolean
  }

  connect() {
    if (!this.activeValue) return

    this.timer = window.setInterval(() => this.poll(), 4000)
    this.poll()
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      })
      if (!response.ok) return

      const payload = await response.json()
      if (this.hasStatusTarget) {
        this.statusTarget.innerHTML = `현재 상태: <strong>${payload.status_label}</strong>`
      }
      if (payload.redirect_url && (payload.ready || payload.status === "failed" || payload.status === "partial_failed")) {
        window.clearInterval(this.timer)
        window.location.href = payload.redirect_url
      }
    } catch (_error) {
      // 상태 polling은 화면 보조 기능이므로 네트워크 오류는 조용히 무시합니다.
    }
  }
}
